import Tiptap from '../../components/tiptap/tiptap';
import './logbook.css';

export default function Logbook() {
  return (
    <div className='logbook-container'>
        <h2>Text Editor</h2>
        <Tiptap />
    </div>
  )
}